import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

import { TranslateService } from 'ng2-translate/ng2-translate';
import { CustomValidators } from 'ng2-validation';
import {ToasterConfig, ToasterService} from "angular2-toaster/angular2-toaster";

import { SettingsService } from '../../../core/settings/settings.service';
import { AuthService } from "../../../shared/authentication/auth.service";
import { User } from "../../users/user";

@Component({
    selector: 'app-login',
    templateUrl: 'changePassword.component.html',
    styleUrls: ['changePassword.component.scss'],
})
export class changePasswordComponent implements OnInit, OnDestroy {

    me: User;
    errorMessage: string;
    valForm: FormGroup;

    showError = false;
    inProgress = false;

    private subscriptions = [];

    constructor(
        public settings: SettingsService,
        private authService: AuthService,
        private router: Router,
        private translate: TranslateService,
        fb: FormBuilder
    ) {

        let id = new FormControl('', Validators.compose([Validators.required]));
        let code = new FormControl('', Validators.required);
        let password = new FormControl('', Validators.required);
        let repassword = new FormControl('', Validators.compose([Validators.required, CustomValidators.equalTo(password)]));

        this.valForm = fb.group({
            'id': id,
            'code': code,
            'password': password,
            'repassword': repassword
        });

        translate.setDefaultLang('en');
        this.setLanguage();
    }

    setLanguage() {
        let availableLangs = this.translate.getLangs();
        let browserLang = this.translate.getBrowserCultureLang();
        if(availableLangs.indexOf(browserLang) != -1) {
            this.translate.use(browserLang);
        }
    }

    submitForm($ev, value: any) {
        $ev.preventDefault();
        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }
        if (this.valForm.valid) {
            this.inProgress = true;
            var subReset = this.authService.resetPassword(this.valForm.value.id, this.valForm.value.code, this.valForm.value.password)
                .subscribe(
                    result => {
                        this.inProgress = false;
                        this.router.navigate(['/login']);
                        this.showError = false;
                    },
                    error =>  {
                        this.inProgress = false;
                        this.errorMessage = <any>error;
                        this.showError = true;
                    }
                );
            this.subscriptions.push(subReset);
        }
    }

    ngOnInit() {}

    ngOnDestroy(): void {
        for (var subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/pages/changePassword/changePassword.component.ts